<template>
  <div class="contents">
    <NJNav></NJNav>
    <div>
      <MachineType></MachineType>
    </div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
  </div>
</template>
<script>
import NJNav from './NJNav'
import MachineType from './MachineType'
export default {
  components:{
    NJNav, MachineType
  },
  data(){
    return{
      realTime: ''
    }
  },
  mounted(){
    // 加载当前日期
    this.realTime = this.dealWithTime(new Date())
    const _this = this
    this.timer = setInterval(function () {
      _this.realTime = _this.dealWithTime(new Date()) // 修改数据date
    }, 1000)
  },
  methods:{
    rangeClick (item) {
      console.log(item)
      this.$router.push('/machinery-distribution')
    },
    // 获取日期
    dealWithTime (data) {
      let formatDateTime
      const Y = data.getFullYear()
      const M = data.getMonth() + 1
      const D = data.getDate()
      let H = data.getHours()
      let Min = data.getMinutes()
      let S = data.getSeconds()
      let W = data.getDay()
      H = H < 10 ? ('0' + H) : H
      Min = Min < 10 ? ('0' + Min) : Min
      S = S < 10 ? ('0' + S) : S
      switch (W) {
        case 0:
          W = '天'
          break
        case 1:
          W = '一'
          break
        case 2:
          W = '二'
          break
        case 3:
          W = '三'
          break
        case 4:
          W = '四'
          break
        case 5:
          W = '五'
          break
        case 6:
          W = '六'
          break
        default:
          break
      }

      formatDateTime = Y + '年' + M + '月' + D + '日 ' + H + ':' + Min + ':' + S + ' 星期' + W;
      return formatDateTime
    }
  }
}
</script>
<style scoped>
  .contents{
    width: 100%;
  }
  .contents::-webkit-scrollbar {display: none;}
</style>




// WEBPACK FOOTER //
// src/components/Index/view/Content.vue